import React, { useContext, useEffect, useState } from "react";
import "./Autograph_collection.css";
import Product_add_to_cart_card from "../common_components/product_add_to_cart_card/Product_add_to_cart_card";
import Sort_By_Offcanvas from "../common_components/sort_By_Offcanvas/Sort_By_Offcanvas";
import Filter_div_btn from "../common_components/filter_div_btn/Filter_div_btn";
import { Products } from "../../utils/luxuryapis/Product/Product";
import { Context } from "../../utils/context";
import { encodeId } from "../../utils/common";

function Autograph_collection() {
  const [showFilter, setShowFilter] = useState(false);
  const [selectedSort, setSelectedSort] = useState("");
  const { IMG_URL } = useContext(Context);
  const [productdata, setproductData] = useState();
  const getAllData = async (selectedSort) => {
    let res;

    res = await Products({ partnership: true, selectedSort });

    if (res?.success) {
      setproductData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllData(selectedSort);
  }, [selectedSort]);
  return (
    <>
      <section className="Autograph_collection">
        <div className="custom_container">
          <div className="heading_holder">
            <h1>THE PARTNERSHIP</h1>
            <h6>
              Mittal Craftworks proudly introduces the Gaurav Pradhan Autograph
              Collection (GPAC)
            </h6>
            <p>
              GPAC is a collaboration with the esteemed Dr. Gaurav Pradhan,
              acclaimed data scientist and leadership coach. GPAC x Copperkraft
              embodies a symphony of luxury & artisanal mastery, offering a
              range of handcrafted copper-ware that transcends mere aesthetics.
              Each piece in this collection carries the distinct logo of Dr.
              Pradhan, symbolizing an intersection of elegance and intellect.
              Moreover, your purchase contributes to a greater purpose: 10% of
              all proceeds from GPAC sales are devoted to the nation-building
              efforts of the Gaurav Pradhan Foundation. Discover the essence of
              sophistication with a soul in the GPAC x Copperkraft series,
              exclusive to MittalCraft.com.
            </p>
          </div>

          <div className="Autograph_collection_card_section">
            <Filter_div_btn
              btnText={"Sort By"}
              onClick={() => {
                setShowFilter(true);
              }}
            />
            <div className="row">
              {productdata?.data?.map((product) => (
                <div className="col-xl-3 col-md-4 col-sm-6 mb-3">
                  <Product_add_to_cart_card
                    product={product}
                    id={product.id}
                    image={IMG_URL + product.image1}
                    url={`/luxury/product-details/${encodeId(product?.id)}`}
                    title={product?.name}
                    mrp={
                      product.product_variants?.[0]?.product_quantities?.[0]
                        ?.mrp
                    }
                    selling_price={
                      product.product_variants?.[0]?.product_quantities?.[0]
                        ?.price
                    }
                    discount={
                      product.discount ||
                      (product?.product_variants?.[0]?.product_quantities?.[0]
                        ?.price > 0
                        ? Math.round(
                            ((product?.product_variants?.[0]
                              ?.product_quantities?.[0]?.mrp -
                              product?.product_variants?.[0]
                                ?.product_quantities?.[0]?.price) /
                              product?.product_variants?.[0]
                                ?.product_quantities?.[0]?.mrp) *
                              100,
                          )
                        : 0)
                    }
                  />
                </div>
              ))}

              {/* <div className="col-xl-3 col-md-4 col-sm-6 mb-3">
                <Product_add_to_cart_card />
              </div>

              <div className="col-xl-3 col-md-4 col-sm-6 mb-3">
                <Product_add_to_cart_card />
              </div>

              <div className="col-xl-3 col-md-4 col-sm-6 mb-3">
                <Product_add_to_cart_card />
              </div> */}
            </div>

            <div className="view_all_text_holder">
              <p>View All</p>
            </div>
          </div>
        </div>
      </section>
      <Sort_By_Offcanvas
        setSelectedSort={setSelectedSort}
        selectedSort={selectedSort}
        show={showFilter}
        handleClose={() => setShowFilter(false)}
      />
    </>
  );
}

export default Autograph_collection;
